<template>
  <div class="billing-card">
    <div class="billing-card__content">{{ content }}</div>
    <div class="billing-card__name">{{ name }}</div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: "",
    },
    content: {
      type: [String,Number],
      default: "",
    },
  },
};
</script>
